module.exports = __webpack_public_path__ + "img/language.e05315e0.png";